export default "__VITE_ASSET__dd5a9c18__"